import { fetchQuery } from 'relay-runtime';
import { graphql } from 'react-relay';
import createEnvironment from '../relayClientEnvironment';
import { getBuyerId } from 'dibs-cookie-jar';
import { init } from './userTracking';
// relay needs this import
import userTracking from './userTracking'; // eslint-disable-line no-unused-vars

export const trackingQuery = graphql`
    query initializeTrackingQuery($hasUserId: Boolean!, $userId: String!, $userIds: [String!]) {
        viewer {
            ...userTracking_viewer @relay(mask: false)
            user(userId: $userId) @include(if: $hasUserId) {
                ...userTracking_user @relay(mask: false)
            }
        }
    }
`;

export default function initializeTracking(environment) {
    environment = environment || createEnvironment();
    const userId = getBuyerId(document.cookie) || '';
    const hasUserId = !!userId;

    return fetchQuery(environment, trackingQuery, {
        userId,
        hasUserId,
        userIds: [userId],
    }).then(({ viewer }) => {
        init({ viewer, user: viewer.user });
    });
}



// WEBPACK FOOTER //
// ./src/utils/initializeTracking.js